// src/redux/settingsPages/userData/userDataActions.js
import { createAsyncThunk } from '@reduxjs/toolkit';
import UserDataAPI from './userDataAPI';

export const fetchUserDataSettings = createAsyncThunk(
  'userData/fetchSettings',
  async (_, { rejectWithValue }) => {
    try {
      return await UserDataAPI.fetchSettings();
    } catch (err) {
      return rejectWithValue(err?.response?.data?.detail || err.message || 'Failed to load settings');
    }
  }
);

export const updateUserDataSettings = createAsyncThunk(
  'userData/updateSettings',
  async (patch, { rejectWithValue }) => {
    try {
      return await UserDataAPI.updateSettings(patch);
    } catch (err) {
      return rejectWithValue(err?.response?.data?.detail || err.message || 'Failed to save settings');
    }
  }
);

export const resetUserDataSettings = createAsyncThunk(
  'userData/resetDefaults',
  async (_, { rejectWithValue }) => {
    try {
      return await UserDataAPI.resetDefaults();
    } catch (err) {
      return rejectWithValue(err?.response?.data?.detail || err.message || 'Failed to reset settings');
    }
  }
);

export const requestDataExport = createAsyncThunk(
  'userData/requestExport',
  async (_, { rejectWithValue }) => {
    try {
      return await UserDataAPI.requestExport();
    } catch (err) {
      return rejectWithValue(err?.response?.data?.detail || err.message || 'Export request failed');
    }
  }
);

export const fetchDataUsage = createAsyncThunk(
  'userData/fetchUsage',
  async (_, { rejectWithValue }) => {
    try {
      return await UserDataAPI.fetchUsage();
    } catch (err) {
      return rejectWithValue(err?.response?.data?.detail || err.message || 'Failed to load data usage');
    }
  }
);

export const deleteAccountThunk = createAsyncThunk(
  'userData/deleteAccount',
  async (_, { rejectWithValue }) => {
    try {
      return await UserDataAPI.deleteAccount();
    } catch (err) {
      return rejectWithValue(err?.response?.data?.detail || err.message || 'Account deletion failed');
    }
  }
);
